module.exports = __webpack_public_path__ + "img/1.cce35d94.png";